import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import React from "react";
var __jsx = React.createElement;
import { useState, useRef, useEffect } from "react";
import { useTranslation } from "@i18n";
import { CDN_LINK } from "@globalConfig";
import stl from "./ShareNP.module.css";
import BottomSheetPopup from "@componentsShared/BottomSheetPopup__OLD/BottomSheetPopup";
import faceBookShareIcon from "./images/facebookShare.svg";
import XshareSVG from "./images/XshareSVG";
import WhatsAppSVG from "./images/WhatsAppSVG";
import ShareSvg from "@/pages/post/PostViewComponents/components/InspectionView/imagesSVG/ShareSvg";
import { trackEvents } from "@/common/events/events";
import ProgressiveImage from "@componentsShared/ProgressiveImage";
import AddToFavoriteButton from "@/common/HOCs/AddToFavorite/AddToFavoriteButton";
import useHelpers from "@hooks/useHelpers";
var ShareNP = function ShareNP(props) {
  var _props$postData3, _props$postData3$deta, _props$postData0, _props$postData0$deta, _props$postData1, _props$postData12, _props$postData12$det;
  var _useTranslation = useTranslation(["web_post_view", "web_common"]),
    t = _useTranslation.t;
  var _useState = useState(false),
    showPopUp = _useState[0],
    setShowPopUp = _useState[1];
  var _useState2 = useState(false),
    CopyDone = _useState2[0],
    setCopyDone = _useState2[1];
  var _useState3 = useState(props.postDynamicLink ? props.postDynamicLink : ""),
    textToCopy = _useState3[0],
    setTextToCopy = _useState3[1];
  var _useHelpers = useHelpers(),
    createUrlAbsolute = _useHelpers.createUrlAbsolute;
  useEffect(function () {
    setTextToCopy(props.postDynamicLink ? props.postDynamicLink : "");
  }, [props.postDynamicLink]);
  useEffect(function () {
    CopyDone && setTimeout(function () {
      setCopyDone(false);
    }, 3000);
  }, [CopyDone]);
  var copyCodeRef = useRef();
  return props.mobileShare ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: stl.mobileShare,
    onClick: function onClick() {
      setShowPopUp(true);
    }
  }, /*#__PURE__*/React.createElement(ProgressiveImage, {
    waitUntilInteractive: true,
    className: stl.androidSH,
    src: CDN_LINK + "/assets/images/android_share.svg",
    alt: "icon",
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("img", {
    className: stl.iosSH,
    src: CDN_LINK + "/assets/images/ios_share.svg",
    alt: "icon",
    width: 24,
    height: 24
  })), /*#__PURE__*/React.createElement(BottomSheetPopup, {
    show: showPopUp,
    onClose: function onClose() {
      return setShowPopUp(false);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.sharePostContainerP
  }, /*#__PURE__*/React.createElement("h3", null, props.reportShare ? t("شارك تقرير فحص", {
    ns: "web_post_view"
  }) : t("شارك هذا الإعلان", {
    ns: "web_post_view"
  })), /*#__PURE__*/React.createElement("div", {
    className: stl.socalBtns
  }, /*#__PURE__*/React.createElement("a", {
    href: "https://www.facebook.com/sharer.php?u=".concat(textToCopy),
    onClick: function onClick() {
      var _props$postData, _props$postData2;
      props.isReport ? trackEvents("inspection_share", _objectSpread(_objectSpread({}, props === null || props === void 0 ? void 0 : (_props$postData = props.postData) === null || _props$postData === void 0 ? void 0 : _props$postData.g4Data), {}, {
        share_medium: "Facebook"
      })) : trackEvents("post_share", _objectSpread(_objectSpread({}, props === null || props === void 0 ? void 0 : (_props$postData2 = props.postData) === null || _props$postData2 === void 0 ? void 0 : _props$postData2.g4Data), {}, {
        share_medium: "Facebook"
      }));
      textToCopy;
    },
    rel: "noopener noreferrer",
    target: "_blank"
  }, /*#__PURE__*/React.createElement("img", {
    width: 48,
    height: 48,
    src: faceBookShareIcon,
    alt: "faceBbok share"
  }), /*#__PURE__*/React.createElement("span", null, t("فيسبوك", {
    ns: "web_post_view"
  }))), /*#__PURE__*/React.createElement("a", {
    href: "https://twitter.com/intent/tweet?original_referer=https%3A%2F%2Fsyarah.com&ref_src=twsrc%5Etfw&tw_p=tweetbutton&url=" + createUrlAbsolute("/cardetail/".concat((_props$postData3 = props.postData) === null || _props$postData3 === void 0 ? void 0 : (_props$postData3$deta = _props$postData3.details) === null || _props$postData3$deta === void 0 ? void 0 : _props$postData3$deta.id)),
    onClick: function onClick() {
      var _props$postData4, _props$postData5;
      props.isReport ? trackEvents("inspection_share", _objectSpread(_objectSpread({}, props === null || props === void 0 ? void 0 : (_props$postData4 = props.postData) === null || _props$postData4 === void 0 ? void 0 : _props$postData4.g4Data), {}, {
        share_medium: "Twitter"
      })) : trackEvents("post_share", _objectSpread(_objectSpread({}, props === null || props === void 0 ? void 0 : (_props$postData5 = props.postData) === null || _props$postData5 === void 0 ? void 0 : _props$postData5.g4Data), {}, {
        share_medium: "Twitter"
      }));
    },
    rel: "noopener noreferrer",
    target: "_blank"
  }, /*#__PURE__*/React.createElement(XshareSVG, null), /*#__PURE__*/React.createElement("span", null, t("تويتر", {
    ns: "web_post_view"
  }))), /*#__PURE__*/React.createElement("a", {
    className: "m-show",
    href: "whatsApp://send?text=%0A%0A ".concat(textToCopy),
    onClick: function onClick() {
      var _props$postData6, _props$postData7;
      props.isReport ? trackEvents("inspection_share", _objectSpread(_objectSpread({}, props === null || props === void 0 ? void 0 : (_props$postData6 = props.postData) === null || _props$postData6 === void 0 ? void 0 : _props$postData6.g4Data), {}, {
        share_medium: "Whatsapp"
      })) : trackEvents("post_share", _objectSpread(_objectSpread({}, props === null || props === void 0 ? void 0 : (_props$postData7 = props.postData) === null || _props$postData7 === void 0 ? void 0 : _props$postData7.g4Data), {}, {
        share_medium: "Whatsapp"
      }));
    },
    rel: "noopener noreferrer",
    target: "_blank"
  }, /*#__PURE__*/React.createElement(WhatsAppSVG, null), /*#__PURE__*/React.createElement("span", null, t("واتساب", {
    ns: "web_post_view"
  })))), /*#__PURE__*/React.createElement("div", {
    className: [stl.copyDataContainer, stl.copyLink].join(" ")
  }, /*#__PURE__*/React.createElement("input", {
    ref: copyCodeRef,
    id: "linkCopy",
    type: "text",
    disabled: "",
    readOnly: true,
    value: decodeURI(textToCopy)
  }), CopyDone ? /*#__PURE__*/React.createElement("span", {
    className: stl.doneCopyCont
  }, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/Check.svg",
    alt: "done"
  }), " ", t("تم نسخ الرابط", {
    ns: "web_post_view"
  })) : /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      var _props$postData8, _props$postData9;
      props.isReport ? trackEvents("inspection_share", _objectSpread(_objectSpread({}, props === null || props === void 0 ? void 0 : (_props$postData8 = props.postData) === null || _props$postData8 === void 0 ? void 0 : _props$postData8.g4Data), {}, {
        share_medium: "Whatsapp"
      })) : trackEvents("post_share", _objectSpread(_objectSpread({}, props === null || props === void 0 ? void 0 : (_props$postData9 = props.postData) === null || _props$postData9 === void 0 ? void 0 : _props$postData9.g4Data), {}, {
        share_medium: "copy_link"
      }));
      copyCodeRef.current.select();
      document.execCommand("copy");
      setCopyDone(true);
    },
    className: "blueBtn"
  }, t("نسخ الرابط", {
    ns: "web_post_view"
  })))))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: [stl.flex, props.btnClass ? props.btnClass : undefined].join(" ")
  }, !props.hideFavaorite && /*#__PURE__*/React.createElement("div", {
    className: stl.conatiner
  }, /*#__PURE__*/React.createElement(AddToFavoriteButton, {
    isFromPostView: true,
    postId: props === null || props === void 0 ? void 0 : (_props$postData0 = props.postData) === null || _props$postData0 === void 0 ? void 0 : (_props$postData0$deta = _props$postData0.details) === null || _props$postData0$deta === void 0 ? void 0 : _props$postData0$deta.id,
    className: stl.FavoriteButton,
    g4_data: props === null || props === void 0 ? void 0 : (_props$postData1 = props.postData) === null || _props$postData1 === void 0 ? void 0 : _props$postData1.g4Data
  }), /*#__PURE__*/React.createElement("span", null, t("أضف إلى المفضلة", {
    ns: "web_post_view"
  }))), /*#__PURE__*/React.createElement("div", {
    className: stl.conatiner,
    onClick: function onClick() {
      setShowPopUp(true);
    }
  }, /*#__PURE__*/React.createElement("img", {
    width: 15,
    height: 16,
    className: "m-hide",
    src: CDN_LINK + "/assets/bundles/share.svg",
    alt: "share"
  }), /*#__PURE__*/React.createElement(ShareSvg, {
    className: "m-show"
  }), /*#__PURE__*/React.createElement("span", {
    className: "m-hide"
  }, props.reportShare ? t("شارك تقرير الفحص", {
    ns: "web_post_view"
  }) : t("شارك الإعلان", {
    ns: "web_post_view"
  })))), /*#__PURE__*/React.createElement(BottomSheetPopup, {
    show: showPopUp,
    onClose: function onClose() {
      return setShowPopUp(false);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.sharePostContainerP
  }, /*#__PURE__*/React.createElement("h3", null, props.reportShare ? t("شارك تقرير فحص", {
    ns: "web_post_view"
  }) : t("شارك هذا الإعلان", {
    ns: "web_post_view"
  })), props.carImg && props.carTitle && /*#__PURE__*/React.createElement("div", {
    className: stl.carTitle_image
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("img", {
    src: props.carImg,
    alt: props.carTitle
  })), /*#__PURE__*/React.createElement("strong", null, props.carTitle)), (props === null || props === void 0 ? void 0 : props.title) && /*#__PURE__*/React.createElement("p", null, props.title), /*#__PURE__*/React.createElement("div", {
    className: stl.socalBtns
  }, /*#__PURE__*/React.createElement("a", {
    href: "https://www.facebook.com/sharer.php?u=".concat(textToCopy),
    onClick: function onClick() {
      var _props$postData10, _props$postData11;
      props.isReport ? trackEvents("inspection_share", _objectSpread(_objectSpread({}, props === null || props === void 0 ? void 0 : (_props$postData10 = props.postData) === null || _props$postData10 === void 0 ? void 0 : _props$postData10.g4Data), {}, {
        share_medium: "Facebook"
      })) : trackEvents("post_share", _objectSpread(_objectSpread({}, props === null || props === void 0 ? void 0 : (_props$postData11 = props.postData) === null || _props$postData11 === void 0 ? void 0 : _props$postData11.g4Data), {}, {
        share_medium: "Facebook"
      }));
      textToCopy;
    },
    rel: "noopener noreferrer",
    target: "_blank"
  }, /*#__PURE__*/React.createElement("img", {
    width: 48,
    height: 48,
    src: faceBookShareIcon,
    alt: "facebbok"
  }), /*#__PURE__*/React.createElement("span", null, t("فيسبوك", {
    ns: "web_post_view"
  }))), /*#__PURE__*/React.createElement("a", {
    href: "https://twitter.com/intent/tweet?original_referer=https%3A%2F%2Fsyarah.com&ref_src=twsrc%5Etfw&tw_p=tweetbutton&url=" + createUrlAbsolute("/cardetail/".concat((_props$postData12 = props.postData) === null || _props$postData12 === void 0 ? void 0 : (_props$postData12$det = _props$postData12.details) === null || _props$postData12$det === void 0 ? void 0 : _props$postData12$det.id)),
    onClick: function onClick() {
      var _props$postData13, _props$postData14;
      props.isReport ? trackEvents("inspection_share", _objectSpread(_objectSpread({}, props === null || props === void 0 ? void 0 : (_props$postData13 = props.postData) === null || _props$postData13 === void 0 ? void 0 : _props$postData13.g4Data), {}, {
        share_medium: "Twitter"
      })) : trackEvents("post_share", _objectSpread(_objectSpread({}, props === null || props === void 0 ? void 0 : (_props$postData14 = props.postData) === null || _props$postData14 === void 0 ? void 0 : _props$postData14.g4Data), {}, {
        share_medium: "Twitter"
      }));
    },
    rel: "noopener noreferrer",
    target: "_blank"
  }, /*#__PURE__*/React.createElement(XshareSVG, null), /*#__PURE__*/React.createElement("span", null, t("تويتر", {
    ns: "web_post_view"
  }))), /*#__PURE__*/React.createElement("a", {
    className: "m-show",
    href: "whatsApp://send?text=%0A%0A ".concat(textToCopy),
    onClick: function onClick() {
      var _props$postData15, _props$postData16;
      props.isReport ? trackEvents("inspection_share", _objectSpread(_objectSpread({}, props === null || props === void 0 ? void 0 : (_props$postData15 = props.postData) === null || _props$postData15 === void 0 ? void 0 : _props$postData15.g4Data), {}, {
        share_medium: "Whatsapp"
      })) : trackEvents("post_share", _objectSpread(_objectSpread({}, props === null || props === void 0 ? void 0 : (_props$postData16 = props.postData) === null || _props$postData16 === void 0 ? void 0 : _props$postData16.g4Data), {}, {
        share_medium: "Whatsapp"
      }));
    },
    rel: "noopener noreferrer",
    target: "_blank"
  }, /*#__PURE__*/React.createElement(WhatsAppSVG, null), /*#__PURE__*/React.createElement("span", null, t("واتساب", {
    ns: "web_post_view"
  })))), /*#__PURE__*/React.createElement("div", {
    className: [stl.copyDataContainer, stl.copyLink].join(" ")
  }, /*#__PURE__*/React.createElement("input", {
    ref: copyCodeRef,
    id: "linkCopy",
    type: "text",
    disabled: "",
    readOnly: true,
    value: decodeURI(textToCopy),
    className: stl.inputDir
  }), /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      var _props$postData17, _props$postData18;
      copyCodeRef.current.select();
      props.isReport ? trackEvents("inspection_share", _objectSpread(_objectSpread({}, props === null || props === void 0 ? void 0 : (_props$postData17 = props.postData) === null || _props$postData17 === void 0 ? void 0 : _props$postData17.g4Data), {}, {
        share_medium: "copy_link"
      })) : trackEvents("post_share", _objectSpread(_objectSpread({}, props === null || props === void 0 ? void 0 : (_props$postData18 = props.postData) === null || _props$postData18 === void 0 ? void 0 : _props$postData18.g4Data), {}, {
        share_medium: "copy_link"
      }));
      document.execCommand("copy");
    },
    className: "blueBtn"
  }, t("نسخ الرابط", {
    ns: "web_post_view"
  }))))));
};
export default ShareNP;